import {
  Component,
  Input,
  OnInit,
  OnDestroy,
  Output,
  EventEmitter
} from '@angular/core';

import {
  trigger,
  state,
  animate,
  transition,
  style,
  keyframes
} from '@angular/animations';

import { Notification } from './models/notification.model';

@Component({
  selector: 'db-notification',
  templateUrl: './notification.component.html',
  styleUrls: ['./notification.component.scss'],
  animations: [
    trigger('bounceIn', [
      state('active', style({
        bottom: '14px',
        'box-shadow': '0 0 8px rgba(0,0,0,0.4)'
      })),
      transition('void => active', [
        animate(300, keyframes([
          style({ bottom: '-200px', opacity: 0, offset: 0 }),
          style({ bottom: '20px', opacity: 1, offset: 0.6 }),
          style({ bottom: '10px', offset: 0.8 }),
          style({ bottom: '14px', offset: 1 }),
        ]))
      ]),
      state('inactive', style({
        bottom: '-200px'
      })),
      transition('active => inactive', [
        animate(300, keyframes([
          style({ bottom: '14px', opacity: 1, offset: 0 }),
          style({ bottom: '0', opacity: 0, transform: 'scale(1.2)', offset: 1 }),
        ]))
      ]),
    ])
  ]
})
export class NotificationComponent implements OnInit, OnDestroy {

  timeoutId: any;
  dismissId: any;
  show = 'inactive';

  @Input() options: Notification;
  @Output() dismissEvent = new EventEmitter();

  constructor() {
    this.show = 'active';
  }

  ngOnInit() {
    this.startTimeout();
  }

  ngOnDestroy() {
    clearTimeout(this.timeoutId);
    clearTimeout(this.dismissId);
  }

  getIconClass() {
    const classPrefix = 'dbi__notification-icon';

    if (this.options.type === 'success') {
      return classPrefix + ' ' + 'dbi__notification-icon--success';
    } else if (this.options.type === 'warning') {
      return classPrefix + ' ' + 'dbi__notification-icon--warning';
    }

    return classPrefix + ' ' + 'dbi__notification-icon--error';
  }

  dismiss(): void {
    this.show = 'inactive';
    this.dimissTimeout();
  }

  private startTimeout() {
    this.timeoutId = setTimeout(() => {
      this.dismiss();
    }, 8000);
  }

  private dimissTimeout() {
    this.dismissId = setTimeout(() => {
      this.dismissEvent.emit();
      this.ngOnDestroy();
    }, 500);
  }
}
